/* eslint-disable no-new-func */
import isPlainObject from "lodash-es/isPlainObject";
import mapValues from "lodash-es/mapValues";
import { newFunction } from './script/newFunction';
import { getCompiledCatchErrorLogger } from './script/evalRuntime';
import { isInteropableString } from './script/interopableString';
export { isInteropableString }; // 历史遗留问题
/**
 * 把js表达式变成一个实际的函数，这个函数（会返回表达式结果，或者如果出错会返回 undefined）
 */
export function makeEvalFn(expr, ctxCount, throwCompiliationError) {
  if (typeof expr !== 'string') return () => undefined;
  const ctxsNames = Array.from({
    length: +ctxCount || 0
  }, (_, i) => `__uc_ctx${i}`);
  const codePrefix = `try { ${ctxsNames.map(n => `with(${n}) {`).join('')}\n`;
  const codeSuffix = `\n${ctxsNames.map(() => '}').join('')}
  } catch (err) {
    ${getCompiledCatchErrorLogger('err', expr, undefined, ctxsNames)}
  }`;
  try {
    try {
      // 第一种 case，代码直接就是表达式
      const fnBody = `${codePrefix}return (${expr}\n);${codeSuffix}`;
      return newFunction(ctxsNames, fnBody);
    } catch (er) {
      // 第二种 case，代码是函数体，存在 "return" 这个关键词（走上面的那个会出语法错误，所以在这里尝试）
      const fnBody = `${codePrefix}${expr}${codeSuffix}`;
      return newFunction(ctxsNames, fnBody);
    }
  } catch (er) {
    if (throwCompiliationError) throw er;
    // 语法错误会到这
    window.ucWarnExpressionError(er, expr, {
      stage: 'compiling'
    });
    return () => undefined;
  }
}
/**
 * 运行js表达式，返回结果。如果出错会返回 undefined
 *
 * 有多个 ctx 的话，越后面的优先级越高
 */
export function tryEval(expr, ...ctxs) {
  if (typeof expr !== 'string') return undefined;
  // eslint-disable-next-line no-param-reassign
  ctxs = ctxs.filter(x => typeof x === 'object' && x !== null);
  const tmpFn = makeEvalFn(expr, ctxs.length);
  return tmpFn(...ctxs);
}
/** 对字符串做花括号插值 */
export function stringInterop(str, ...ctxs) {
  if (typeof str !== 'string') return str;
  if (str.startsWith('{{') && str.indexOf('}}') === str.length - 2) {
    // 整个字符串就是一个表达式，返回值就不是 string
    return tryEval(str.slice(2, -2), ...ctxs);
  }
  return str.replace(/{{([\d\D]+?)}}/g, (_, path) => tryEval(path, ...ctxs));
  // return str.replace(/\{\{([^}]+)\}\}/g, (_, path) => get(ctx, path.trim()));
}
export default stringInterop;
/**
 * 对 prop 值做花括号的插值，
 *
 * 有多个 ctx 的话，越后面的优先级越高
 */
export function deepInterop(value, ...ctxs) {
  const process = val => {
    if (typeof val === 'string') return stringInterop(val, ...ctxs);
    if (Array.isArray(val)) return val.map(process);
    if (isPlainObject(val)) return mapValues(val, process);
    return val;
  };
  return process(value);
}
//# sourceMappingURL=stringInterop.js.map
